import auth from '../apis/auth';
import {
  INIT_INTERVIEW,
  RECORD_ANSWER,
  FETCH_METRIC_STEP_START,
  FETCH_METRIC_STEP_SUCCESS,
  FETCH_METRIC_STEP_ERROR,
  FETCH_PERSONNEL_STEP_START,
  FETCH_PERSONNEL_STEP_SUCCESS,
  FETCH_PERSONNEL_STEP_ERROR,
  FETCH_OPERATIONAL_STEP_START,
  FETCH_OPERATIONAL_STEP_SUCCESS,
  FETCH_OPERATIONAL_STEP_ERROR,
} from "./types";

// initialize (both modes)
export const initInterview = (industry, metricsOrOutcome, mode) => ({
  type: INIT_INTERVIEW,
  payload: { industry, data: metricsOrOutcome, mode }
});

export const recordAnswer = (answer) => ({
  type: RECORD_ANSWER,
  payload: answer
});

// Metric mode
export const fetchMetricStep = (industry, outcome, purpose, reason, history, metrics, extra_context) => async (dispatch) => {
  dispatch({ type: FETCH_METRIC_STEP_START });
  try {
    const res = await auth.post("/api/interview/guided_metrics", {
      industry_context: industry,
      outcome,
      purpose,
      reason,
      history,
      metrics,
      extra_context
    });
    dispatch({ type: FETCH_METRIC_STEP_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: FETCH_METRIC_STEP_ERROR, payload: err.response?.data || err });
  }
};

// Personnel mode
export const fetchPersonnelStep = (industry, outcome, history, category, subjectType, driver, positive_driver) => async (dispatch) => {
  dispatch({ type: FETCH_PERSONNEL_STEP_START });
  try {
    const res = await auth.post("/api/interview/guided_personnel_efficiency", {
      industry_context: industry,
      outcome,
      history,
      category,
      type: subjectType,
      driver,
      positive_driver
    });
    dispatch({ type: FETCH_PERSONNEL_STEP_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: FETCH_PERSONNEL_STEP_ERROR, payload: err.response?.data || err });
  }
};

// Personnel mode
export const fetchOperationalStep = (industry, outcome, history, category, subjectType, driver, multiple, frequency, positive_driver) => async (dispatch) => {
  dispatch({ type: FETCH_OPERATIONAL_STEP_START });
  try {
    const res = await auth.post("/api/interview/guided_operational_efficiency", {
      industry_context: industry,
      outcome,
      history,
      category,
      type: subjectType,
      multiple,
      frequency,
      driver,
      positive_driver
    });
    dispatch({ type: FETCH_OPERATIONAL_STEP_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: FETCH_OPERATIONAL_STEP_ERROR, payload: err.response?.data || err });
  }
};